import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="dropdown"
export default class extends Controller {
  static targets = ["menu", "chevron"];

  initialize() {
    // Bind once so disconnect() removes the same function instances;
    // rebinding in disconnect() would leak listeners on every Turbo visit.
    this.hide = this.hide.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
  }

  connect() {
    document.addEventListener("click", this.hide);
    document.addEventListener("keydown", this.onKeydown);
  }

  disconnect() {
    document.removeEventListener("click", this.hide);
    document.removeEventListener("keydown", this.onKeydown);
  }

  toggle() {
    this.setOpen(this.menuTarget.classList.contains("hidden"));
  }

  hide(event) {
    if (!this.element.contains(event.target)) {
      this.setOpen(false);
    }
  }

  onKeydown(event) {
    if (event.key === "Escape") {
      this.setOpen(false);
    }
  }

  setOpen(open) {
    this.menuTarget.classList.toggle("hidden", !open);
    if (this.hasChevronTarget) {
      this.chevronTarget.classList.toggle("rotate-180", open);
    }
  }
}
